<template>
  <div id="mnd-anchor"></div>
</template>

<script>
export default {
  name: 'MyNewsdeskEmbed',

  mounted() {
    if (document.getElementById('mnd-script')) return

    const s = document.createElement('script')
    s.id = 'mnd-script'
    s.src = '//olsson-parts.mynewsdesk.com/hosted_newsroom.js'
    s.async = true

    document.getElementById('mnd-anchor').appendChild(s)
  }
}
</script>
